import React from 'react';
import { ONBOARDING_CURRENCIES } from '../onboardingConstants';
import AccountDetailsStep from './AccountDetailsStep';
import ConfirmStep from './ConfirmStep';
import OrganisationStep from './OrganisationStep';
import PlanStep from './PlanStep';

export default function OnboardingRegistrationStepContent({
  stepIndex,
  activeStep,
  form,
  registration,
  isSubmitting,
  linkParams: _linkParams,
  showSkipOrganisation,
  showSkipPlan,
  showBrokerPlanQuestion,
  brokerCreatingPlan,
  emailFromLink,
  isVerifyingEmail,
  emailAlreadyRegistered,
  emailAlreadyRegisteredMessage,
  onClearEmailVerificationError,
  onGoToLogin,
  onContinue,
  onBack,
  onSkipOrganisation,
  onSkipPlan,
  onComplete,
}) {
  if (stepIndex !== activeStep) return null;

  if (stepIndex === 0) {
    return (
      <AccountDetailsStep
        form={form}
        initialValues={registration.account}
        isSubmitting={isSubmitting}
        isVerifyingEmail={isVerifyingEmail}
        emailFromLink={emailFromLink}
        emailAlreadyRegistered={emailAlreadyRegistered}
        emailAlreadyRegisteredMessage={emailAlreadyRegisteredMessage}
        onClearEmailVerificationError={onClearEmailVerificationError}
        onGoToLogin={onGoToLogin}
        showBrokerPlanQuestion={showBrokerPlanQuestion}
        brokerCreatingPlan={brokerCreatingPlan}
        onContinue={onContinue}
      />
    );
  }

  if (stepIndex === 1) {
    return (
      <OrganisationStep
        form={form}
        initialValues={registration.organisation}
        isSubmitting={isSubmitting}
        showSkip={showSkipOrganisation}
        onBack={onBack}
        onSkip={onSkipOrganisation}
        onContinue={onContinue}
      />
    );
  }

  if (stepIndex === 2) {
    return (
      <PlanStep
        form={form}
        initialValues={registration.plan}
        currencies={ONBOARDING_CURRENCIES}
        isSubmitting={isSubmitting}
        showSkip={showSkipPlan}
        onBack={onBack}
        onSkip={onSkipPlan}
        onContinue={onContinue}
      />
    );
  }

  return (
    <ConfirmStep
      form={form}
      registration={registration}
      isSubmitting={isSubmitting}
      onBack={onBack}
      onComplete={onComplete}
    />
  );
}
